export default __webpack_public_path__ + "44c1a142ebbcfa6eb02e6cdc635cce48.png";